import { render, staticRenderFns } from "./ConfigureCompanyDocument.vue?vue&type=template&id=51058f75&scoped=true"
import script from "./ConfigureCompanyDocument.vue?vue&type=script&lang=js"
export * from "./ConfigureCompanyDocument.vue?vue&type=script&lang=js"
import style0 from "./ConfigureCompanyDocument.vue?vue&type=style&index=0&id=51058f75&prod&lang=scss&scoped=true"
import style1 from "./ConfigureCompanyDocument.vue?vue&type=style&index=1&id=51058f75&prod&lang=scss"
import style2 from "./ConfigureCompanyDocument.vue?vue&type=style&index=2&id=51058f75&prod&scoped=true&lang=css"
import style3 from "./ConfigureCompanyDocument.vue?vue&type=style&index=3&id=51058f75&prod&scoped=true&lang=css"
import style4 from "./ConfigureCompanyDocument.vue?vue&type=style&index=4&id=51058f75&prod&lang=css"
import style5 from "./ConfigureCompanyDocument.vue?vue&type=style&index=5&id=51058f75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51058f75",
  null
  
)

export default component.exports